module.exports = __webpack_public_path__ + "img/play-chard.35f12501.svg";